import modalConnecting from './modalConnecting'
import modalDisconnected from './modalDisconnected'
import modalConfirmCloseRemoteSession from './modalConfirmCloseRemoteSession'
import modalConnectionUnstable from './modalConnectionUnstable'
import modalCapturingSuspended from './modalCapturingSuspended'
import modalKvmSuspended from './modalKvmSuspended'
import modalScreenNotSharingIOS from './modalScreenNotSharingIOS'
import modalAudioCharRequestByPeer from './modalAudioCharRequestByPeer'
import modalAudioCharRequestCancelByPeer from './modalAudioCharRequestCancelByPeer'

// IMPORTANT: all modals shouldDisplay are called in order and the first
// returning modalData will be the active one; the next are ignored
// so the most important (topmost) modals should be the first in array
const modals = [
  modalDisconnected,
  modalConfirmCloseRemoteSession,
  modalConnectionUnstable,
  modalAudioCharRequestCancelByPeer,
  modalAudioCharRequestByPeer,
  modalScreenNotSharingIOS,
  modalCapturingSuspended,
  modalKvmSuspended,
  modalConnecting,
]

// collect propTypes from each modal
const modalsPropTypes = modals.reduce((acc, modal) => {
  return { ...acc, ...modal.stateProps }
}, {})

// get first modal that should be displayed
// returns null | modalData
const getActiveModal = ({ state, dispatch, translate }) => {
  let modalData = null

  // find the first modal that should be displayed
  modals.find((modal) => {
    if (modal.shouldDisplay(state)) {
      modalData = modal.getModalData({
        state,
        dispatch,
        translate,
      })
      return true // stop find
    }
    return false // continue find
  })

  return modalData
}

// state props values helpers
const statePropsMap = Object.entries(modals
  .map(({ stateProps }) => (Object.entries(stateProps)))
  .reduce((acc, statePropsEntries) => {
    statePropsEntries.forEach(([statePropPath]) => {
      acc[statePropPath] = statePropPath.split('.')
    })
    return acc
  }, {}))

const valueFromStateCb = (acc, key) => {
  if (!acc) { return null }
  const val = acc[key]
  if (val === undefined) { return undefined }
  return val
}

const valueFromState = (state, keys) => {
  return keys.reduce(valueFromStateCb, state)
}

// getStateProps - AppModal mapStateToProps use it to retrieve from state the values
// of all props declared by modals
const getStateProps = (state) => statePropsMap.reduce((props, [propName, keys]) => {
  props[propName] = valueFromState(state, keys)
  return props
}, {})

export {
  modalsPropTypes,
  getActiveModal,
  getStateProps,
}
